import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative z-50 w-full h-full",
  "aria-labelledby": "slide-over-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_4 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_5 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_6 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_7 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl px-6 sm:px-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "TRAILER", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg pb-6" }, "Skift trailer", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = ["disabled"]

import bookingRepository from '@/repositories/bookings/bookingRepository';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'trailerDetailsComponent',
  props: {
  isVisible: Boolean
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const id = route.params.id
const booking = computed(() => store.getters['bookingStore/booking'])

console.log('bookin', booking.value)

const close = () => {
  store.commit('bookingStore/toggleSetTrailer')
}

const options = ref<Array<any>>([]);
const currentTrailer = ref();
const selectedOption = ref();

const isButtonDisabled = computed(() => {
  return !selectedOption.value || currentTrailer.value === selectedOption.value;
});

const fetchAvailableTrailers = async () => {
  try {
    const response = await bookingRepository.getAvailableTrailers();
    if (response && response.data) {
      options.value = response.data.map((trailer: any) => ({
        vehicleId: trailer.id,
        driverId: trailer.driverId,
        label: trailer.name
      }));
      store.commit('bookingStore/setTrailerOptions', options.value)
      currentTrailer.value = options.value.find(option => option.label === booking.value.trailerName)
      selectedOption.value = currentTrailer.value
    }
  } catch (error) {
    console.log(error)
  }
}

fetchAvailableTrailers()

watch(() => props.isVisible, (value) => {
  if (value) {
    currentTrailer.value = options.value.find(option => option.label === booking.value.trailerName)
    selectedOption.value = currentTrailer.value
  } else {
    console.log('close')
  }
})

async function changeTrailer () {
  const vehicleId = selectedOption.value.vehicleId
  const driverId = selectedOption.value.driverId
  try {
    const response = await bookingRepository.changeTrailerForDriver({ trailerId: vehicleId, driverId: driverId, bookingId: booking.value.id, time: new Date() })
    store.commit('bookingStore/setBookingTrailer', { name: response.data.name, id: vehicleId })
    currentTrailer.value = options.value.find(x => x.vehicleId === response.data.id)
    close()
  } catch (error) {
    console.log(error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _withDirectives(_createElementVNode("select", {
                        id: "trailer-select",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOption).value = $event)),
                        class: "block w-full rounded-md border border-gray-300 p-2 text-base shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option.id,
                            value: option
                          }, _toDisplayString(option.label), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, selectedOption.value]
                      ]),
                      _createElementVNode("button", {
                        onClick: changeTrailer,
                        class: _normalizeClass(["mt-2 flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary", { 'opacity-20 pointer-events-none': isButtonDisabled.value }]),
                        disabled: isButtonDisabled.value
                      }, " Skift trailer ", 10, _hoisted_16)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})